export default {
  closeButtonBoxShadow: Styles.boxShadow,
  modalContentBackground: Styles.color.grey.five,
  modalWrapperBackground: undefined,
};
